import { IApplicationState, IPageState } from '../../types/redux';

const defaultState: IPageState = {
  platform: undefined,
  deviceType: 'phone',
};

export function pageReducer(state: IApplicationState['page'] = defaultState) {
  return state;
}
